import React from 'react';

import logo from 'assets/images/ap_logo_final_RGB_800px.png';
import './not-found.scss';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found__content">
        <a
          className="not-found__logo-link"
          href="/"
        >
          <img
            className="not-found__logo"
            src={logo}
          />
        </a>
        <div className="not-found__message">
          <h1 className="not-found__title">Oops! We couldn’t find the page you’re looking for!</h1>
          <a
            className="not-found__link"
            href="https://www.aisleplanner.com"
          >
            <i className="fa fa-long-arrow-alt-left"/> Home Page
          </a>
          <a
            className="not-found__link not-found__link--right"
            href="https://pro.aisleplanner.com/blog"
          >
            Pro Blog <i className="fa fa-long-arrow-alt-right"/>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
